import * as React from "react";


export const ConfirmationPopUp = (props) => {

    /*  const confirmation = () => {
         props.confirmation(props.index)
     } */

    return (<>
        <div className="add_rate_popup cntnt_wrpr">
            <div className="alert-box">
                {props.message}
            </div>
            <div className="footer">
                <button className="mla ttuc fs12 text mini" onClick={() => props.close()}>Cancel</button>
                <button className="mla ttuc fs12 primary mini" onClick={props.confirmation}> YES </button>
            </div>
        </div>
    </>)
}